import { ArgumentException } from "./ArgumentException";
import { TemplateString } from "./TemplateString";
export class ArgumentNullException extends ArgumentException {
  constructor(message, paramName, innerException) {
    super(TemplateString`Parameter '${'paramName'}' can not be neither 'null', 'undefined' or empty.`.prepend(message), paramName, innerException);
  }

}
